import { LOCAL_STORAGE } from "@ng-toolkit/universal";
import { Injectable, Inject } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../environments/environment";
import { Http, Response } from "@angular/http";
import { RequestOptions, Headers } from "@angular/http";
import { Router, NavigationStart } from "@angular/router";
import { map } from "rxjs/operators";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/throw";
import "rxjs/add/operator/catch";
import "rxjs/add/operator/map";
import { throwError } from "rxjs/internal/observable/throwError";
// import constant from "./assets/data/constant";

@Injectable()
export class DataService {
  protected headers: Headers;
  protected options: {};
  protected post: {};
  protected user: { token: String };
  protected url: string;
  protected playlist: any[];

  constructor(
    @Inject(LOCAL_STORAGE) private localStorage: any,
    public http: HttpClient,
    private router: Router
  ) {
    // console.log('callPlaylist');
    // this.headers = new Headers();
    // this.headers.append('Content-Type', 'text/html');
    // // this.headers.append('Access-Control-Allow-Origin', '*');
    // // this.headers.append('Accept', 'application/json');
    // this.options = new RequestOptions({
    //   headers: this.getHeaders()
    //   // method: 'POST'
    // });

    let headers = new HttpHeaders();
    headers.append("accept", "application/json");
    headers.append("content-type", "application/x-www-form-urlencoded");
    // headers.append('Content-Type', 'text/plain');
    // headers.append('Accept', 'application/x-www-form-urlencoded');
    // headers.append("Access-Control-Allow-Methods", "GET, POST");
    headers.append("Origin", "*");
    headers.append("Access-Control-Allow-Origin", "*");
    this.options = { headers };
    // headers = headers.append('zumo-api-version', '2.0.0');
    console.log("constructor DataService");
    this.callPlaylist().subscribe();
    this.callConstants().subscribe();
  }

  getHeaders() {
    return this.headers;
  }

  getOptions() {
    return this.options;
  }

  query(option: any) {
    let url = "";
    if (option.urlFull !== undefined) {
      url = option.urlFull;
    } else {
      url = "./assets/data/" + option.url;
    }

    if (option.method === undefined) {
      option.method = "GET";
    }

    if (option.method === "GET") {
      return this.http.get(url, this.getOptions());
    }

    if (option.method === "POST") {
      const data = option.data;
      return this.http.post(url, data, this.getOptions());
    }
  }

  setConstant(data) {
    this.localStorage.setItem("currentConstant", JSON.stringify(data));
  }

  getConstant() {
    let data: string;
    data = this.localStorage.getItem("currentConstant");
    if (data) {
      return JSON.parse(data);
    } else {
      return {};
    }
  }

  setData(data) {
    this.localStorage.setItem("currentData", JSON.stringify(data));
  }

  currentData() {
    let data: string;
    data = this.localStorage.getItem("currentData");
    if (data) {
      return JSON.parse(data);
    } else {
      return {};
    }
  }

  setPlayer(player) {
    this.localStorage.setItem("currentPlayer", JSON.stringify(player));
  }

  currentPlayer() {
    let player: string;
    player = this.localStorage.getItem("currentPlayer");
    if (player) {
      return JSON.parse(player);
    } else {
      return {};
    }
  }

  getPlaylist() {
    return this.currentData().items;
  }

  getCategories() {
    return this.currentData().categories;
  }

  getPopular() {
    return this.currentData().popular;
  }

  callInfo(player) {
    var url = player.url;
    var final = url.substr(url.lastIndexOf("/") + 1);
    const attr: any = {};
    attr.data = {};
    // attr.urlFull = 'http://v4.mystreamplayer.com/streamdata.php?h=listen.181fm.com&p=7080&f=ice&i=' + final;
    attr.urlFull =
      "http://player.181fm.com/streamdata.php?h=listen.181fm.com&p=7080&f=ice&i=" +
      final;
    attr.method = "GET";
    return this.query(attr)
      .pipe(
        map((data: any) => {
          let info: any = {};
          info = data;
          const song = info.song;
          if (song) {
            const explode = song.split("-");
            info.artist = explode[0];
            info.title = explode[1];
          }
          return info;
        })
      )
      .catch(this.handleError);
  }

  callPlaylist() {
    const attr: any = {};
    attr.data = {};
    attr.url = "data.json";
    attr.method = "GET";
    return this.query(attr)
      .pipe(
        map((data: any) => {
          this.proccessMap(data);
          const items: any = data;
          this.setData(items);
          return items;
        })
      )
      .catch(this.handleError);
  }

  callConstants() {
    const attr: any = {};
    attr.data = {};
    attr.url = "constant.json";
    attr.method = "GET";
    return this.query(attr)
      .pipe(
        map((data: any) => {
          this.proccessMap(data);
          const items: any = data;
          this.setConstant(items);
          return items;
        })
      )
      .catch(this.handleError);
  }

  callPages(file) {
    const attr: any = {};
    attr.data = {};
    attr.url = file + ".json";
    attr.method = "GET";
    return this.query(attr)
      .pipe(
        map((data: any) => {
          this.proccessMap(data);
          const items: any = data;
          return items;
        })
      )
      .catch(this.handleError);
  }

  getStation(slug: string) {
    let result: any = {};
    const data = this.currentData().items;
    if (data) {
      data.forEach(function(r, k) {
        const playlist = r.playlist;
        playlist.forEach(function(p, j) {
          const sl = p.slug;
          if (sl.indexOf(slug) !== -1) {
            result = p;
            return;
          }
        });
      });
    }
    return result;
  }

  getCategory(slug: string) {
    let result: any = {};
    const data = this.currentData().items;
    if (data) {
      data.forEach(function(r, k) {
        const sl = r.slug;
        if (sl.indexOf(slug) !== -1) {
          result = r;
          return;
        }
      });
    }
    return result;
  }

  proccessMap(data: any) {
    if (data.status === "success") {
      if (data.msg) {
        // this.alertService.success(data.msg);
      }
      return data;
    } else {
      if (data.msg) {
        // this.alertService.error(data.msg);
      }
      return data;
    }
    // return data;
  }

  // Displays the error message
  handleError(e: any) {
    // let errorMessage: string;
    // errorMessage = response.message ? response.message : response.toString();

    // this.alertService.error('SYSTEM: ' + errorMessage);
    // In real world application, call to log error to remote server
    // logError(error);
    // This returns another Observable for the observer to subscribe to
    // return Observable.throw(errorMessage);
    return throwError(e);
  }

  errorHandler(error: any): void {
    console.log(error);
  }
}
